

import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover';
var classNames = require('classnames')

export const OperatorsPopover = (props) => {
  return (
      <SkyInformationPopover eventId={'operators'}>
        <div className="text-small">For each operator, select the relevant training level and flying hours experience.</div>
        <div className="text-small">This will impact the total premium</div>
      </SkyInformationPopover>
  );
}